import { ISectionState } from './types';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {ISectionOptions} from "external-services/section-groups-service/type";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import SectionGroupsService from 'external-services/section-groups-service/sectionGroups.service';
import {CONTACT_MSG, PROBLEMS_MSG, REFRESH_MSG} from "appRoot/app-error-messages";
import {errorStateActions, getAccordionDetail} from "app/reducers/errorState/slice";

const NS = 'sectionSlice';

const initialState: ISectionState = {
  currentSections: [],
  selectedSection: null,
};


export const defineAvailableSections = createAsyncThunk(
  'section/defineAvailableSections',
  async (
    payload: {
      sectionIds: string[];
    },
    { dispatch, getState }
  ): Promise<ISectionOptions[]> => {
    let sections: ISectionOptions[] = null;
    try {
      const sectionsLookUp = await SectionLookupService.getSectionsLookUp();
      if (typeof sectionsLookUp !== 'boolean') {
        const sectionGroups = await SectionGroupsService.getSectionGroups();
        sections = SectionGroupsService.getSectionOptions(
          sectionsLookUp,
          sectionGroups,
          payload.sectionIds
        );
      } else {
        sections = [];
      }
    } catch (e) {
      console.log(NS, 'sections err', e);
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Problem loading "Sections"',
          errorMessage: `There was an error trying to load data for "sections". \n\n${PROBLEMS_MSG} ${REFRESH_MSG} \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(e),
        })
      );
      sections = [];
    }
    return sections;
  }
);


const sectionSlice = createSlice({
  name: 'section',
  initialState,
  reducers: {
    setSection: (state: ISectionState, action: PayloadAction<ISectionOptions>) => {
      state.selectedSection = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(loadSection.fulfilled, (state: ISectionState, action) => {
    //   state.currentSections = action.payload || []
    // }),
    builder.addCase(defineAvailableSections.fulfilled, (state: ISectionState, action) => {
      state.currentSections = action.payload || [];
    });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = sectionSlice;
// Extract and export each action creator by name
export { actions as sectionActions };
// Export the reducer, either as a default or named export
export default reducer;
